<template>
  <footer>
    <div class="f-r-item">
      <img class="footer-icon" src="../images/footer-icon.png" alt="">
    </div>
    <nav>
      <div class="f-r-item" v-for="item of footerItemList" @click="footerItemClick(item)">
        {{item.footerTitle}}
      </div>
    </nav>
    <div class="des">
      免责声明：本站内容仅供参考与交流，不进行任何现金交易行为。本网站不承担由于内容的合法性所引起的一切争议和法律责任。&nbsp;&nbsp;&nbsp;&nbsp;
      CopyRight 2024台湾星海彩 &nbsp;版权所有All Rights Reserverd
    </div>
  </footer>
</template>

<script>
export default{
  data(){
    return{
      footerItemList:[
        {
          footerTitle:'首页',
          path:'',
        },
        {
          footerTitle:'开奖记录',
          path:'record',
        },
        {
          footerTitle:'正版图库',
          path:'gallery',
        },
        {
          footerTitle:'彩票介绍',
          path:'introduce',
        },
        {
          footerTitle:'新闻资讯',
          path:'hotnews',
        },
        {
          footerTitle:'开奖公告',
          path:'openbonus',
        },
        {
          footerTitle:'五行号码',
          path:'five',
        },
        {
          footerTitle:'生肖属性',
          path:'zodiac',
        },
        {
          footerTitle:'波色对照',
          path:'ballcolor',
        }
      ],
    }
  },
  methods:{
    footerItemClick(item){
      this.$router.push(`/${item.path}`)
      // return;
      // let scrollTop = item.scrollTop;
      // this.$router.push('/')
      // document.documentElement.scrollTop = this.ratioPxByWindow(scrollTop);
    },
    ratioPxByWindow(value){
      const standard = 750;
      return innerWidth * value / standard;
    }
  },
}
</script>

<style scoped>
  footer{
    background:#000000;
    color:white;
    padding-top:.85rem;
    padding-bottom:.68rem;
  }
  .footer-icon{
    width:2.68rem;
  }
  .f-r-item{
    padding:0 .24rem;
  }
  footer nav{
    display:flex;
    align-items: center;
    overflow:hidden;
    height:1.58rem;
    width: 88%;
    margin: auto;
    border-top:.01rem solid;
  }
  footer nav .f-r-item{
    height:.24rem;
    line-height: 1;
    font-size:.22rem;
    border-right:.01rem solid white;
    cursor:pointer;
  }
  footer nav .f-r-item:last-child{
    border-right:none;
  }
  footer .des{
    width: 88%;
    margin:0 auto;
    color: #666666;
    font-size: .14rem;
  }
  footer > .f-r-item{
    width:88%;
    margin:auto;
    padding-bottom:.66rem;
  }
</style>